<template>
    <Head>
    <title>Edit Announcement | {{$page.props.appName}}</title>
    <meta name="description" :content="'Edit Announcements ' + $page.props.appName">
    </Head>
      <div class="p-3 flex flex-wrap">
        <div
            class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3 mx-2 mt-1"
        >
            <div class="bg-blue-200 p-2 font-semibold border-l-4 border-blue-300">
                <p>Editing an annoucement will mean it gets re-sent to all staff.</p>
            </div>
            <form @submit.prevent="false">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                    <div class="pr-6 pb-8 w-full lg:w-1/2">
                        <label for="text-input-17" class="form-label"
                            >Announcement Title:</label
                        >
                        <input type="text" class="form-input" v-model="this.form.announcement_title">
                    </div>
                    <div class="pr-6 pb-8 w-full lg:w-full">
                        <label for="text-input-17" class="form-label"
                            >Annoucement Message</label
                        >
                        <textarea
                            v-model="this.form.announcement_message"
                            cols="30" rows="10"
                            class="form-input"
                        />
                    </div>
                    <div class="pr-6 pb-8 w-full lg:1/2">
                        <label for="text-input-17" class="form-label"
                            >Announcement Group</label
                        >
                        <select name="" class="form-select" v-model="this.form.announcement_group_id">
                            <option value="ALL">ALL</option>
                            <option :value="department.id" :key="department.id" v-for="department in departments">{{department.department_name}}</option>
                        </select>
                    </div>
                </div>
                </form>

                <div class="w-full">
                    <button
                        class="
                            bg-red-400
                            text-white
                            font-bold
                            p-2
                            ml-6
                            mt-3
                            float-left
                        "
                        :disabled="form.processing"
                        @click="deletedata()"
                    >
                        DELETE ANNOUNCEMENT
                    </button>
                    <button
                        type="submit"
                        class="
                            bg-black
                            text-white
                            font-bold
                            p-2
                            ml-6
                            mt-3
                            float-right
                        "
                        :disabled="form.processing"
                        @click="store()"
                    >
                        EDIT ANNOUNCEMENT
                    </button>
                </div>
        </div>

          <div
            class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3 mx-2 mt-1"
        >
          <h1 class="font-semibold">File</h1>
          <div class="p-2">
              <div v-if="file?.filename">
                  <p>The file uploaded to this announcement : <br> <a class="cursor-pointer text-blue-600" :href="'/file/' + file.filename">{{file.filename}}</a></p>
              </div>
            <div v-if="this.form.file == null && this.file == null"> <p>No file were uploaded with this announcement, but you can upload one below.</p> </div>
            <div v-else> File ready to upload : {{filename}} </div>
              <input type="file" ref="front" class="hidden"  @change="onFileChange" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*">
             <button
                        type="submit"
                        class="
                            bg-black
                            text-white
                            font-bold
                            p-2
                            ml-6
                            mt-3
                        "
                        :disabled="form.processing"
                        @click="$refs.front.click()"
                    >
                      UPLOAD FILE
                    </button>

          </div>
  
            
          </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import moment from 'moment';
import { Head } from '@inertiajs/inertia-vue3'

export default {
    props: {
        announcement : Object,
        departments : Object,
        id: String,
        file : Object
    },
    layout: Layout,
    components: { Link, Pagination,Head },
    data() {
        return {
            form: this.$inertia.form({
                announcement_title : this.announcement.announcement_title,
                announcement_message : this.announcement.announcement_message,
                announcement_group_id : this.announcement.announcement_group,
                file : null,
                filename : ''
            }),
        };
    },
    methods: {
        store() {
            this.form.post("/admin/announcements/edit/" + this.id);
        },
        deletedata() {
            if (confirm("Are you sure you want to delete this announcement-? Be aware this will be deleted for all staff too.")) {
                this.$inertia.delete("/admin/announcements/edit/" + this.id);
            }
        },
      onFileChange(e) {
      const file = e.target.files[0];
      this.filename = file.name;
      this.form.file = file;
    }
    },
};
</script>
